import React from 'react';
import {connect} from 'react-redux';

import ItemsFilter from '../../shared/components/items-filter';

class ProductFilter extends React.PureComponent  {

    render(){
        const { products, condition, prices, deals } = this.props;
        const conditionParams = {prices, deals};

        return(
            <ItemsFilter items={products} condition={(prd)=>condition(prd, conditionParams)}>
                {this.props.children}
            </ItemsFilter>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return({
        prices: state.productData.productInfo.productPrices,
        deals: state.deals
    })
}

export default connect(mapStateToProps, null)(ProductFilter);
